import { render, staticRenderFns } from "./ChoiceEdit.vue?vue&type=template&id=0df91324&scoped=true&"
import script from "./ChoiceEdit.vue?vue&type=script&lang=js&"
export * from "./ChoiceEdit.vue?vue&type=script&lang=js&"
import style0 from "./ChoiceEdit.vue?vue&type=style&index=0&id=0df91324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df91324",
  null
  
)

export default component.exports